import React from 'react';
import { Form, Input } from '../components';
import { EXTENSION_NAME_OPTIONS } from '../constants';

const CreateAccountForm = ({ value, onChange, helperMessage }) => {
  
  return (
    <>
      <Form.FormGroup className="form-group-2">
        <Input autoComplete='off' label="Email" name="email" onChange={onChange} value={value.email} helperMessage={helperMessage}/>
        <Input type="mask" mask="99999999999" placeholder="09000000000" label="Mobile Number" name="mobile_number" onChange={onChange} value={value.mobile_number} helperMessage={helperMessage}/>
      </Form.FormGroup>
      <Form.FormGroup className="form-group-2">
        <Input type="password_strength" label="Password" name="password" onChange={onChange} value={value.password} helperMessage={helperMessage}/>
        <Input type="password" label="Password Confirmation" name="password_confirmation" onChange={onChange} value={value.password_confirmation} helperMessage={helperMessage}/>
      </Form.FormGroup>
      <Form.FormGroup className="form-group-2">
        <Input label="First Name" name="first_name" onChange={onChange} value={value.first_name} helperMessage={helperMessage}/>
        <Input label="Middle Name" name="middle_name" onChange={onChange} value={value.middle_name} helperMessage={helperMessage}/>
        <Input label="Last Name" name="last_name" onChange={onChange} value={value.last_name} helperMessage={helperMessage}/>
        <Input type="select" options={EXTENSION_NAME_OPTIONS} label="Extension Name" name="extension_name" onChange={onChange} value={value.extension_name} helperMessage={helperMessage}/>
      </Form.FormGroup>
    </>
  )
}

export default CreateAccountForm